var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { SetPlaceSourceModalData } from './set.place.source.modal.provider';
var SetPlaceSourceModalComponent = /** @class */ (function (_super) {
    __extends(SetPlaceSourceModalComponent, _super);
    function SetPlaceSourceModalComponent(fb, accountApiService, alertify, formBuilder, modalService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.placeSource = 'facebook';
        // public isAreaBusiness = false;
        _this.businessType = 'normal';
        _this.isUseIgDefaultCustomPlaceCategories = true;
        _this.showPlaceImageCount = 5;
        _this.nearbyPlacesDefaultRange = 2;
        _this.initial = 'facebook';
        _this.googleKey = '';
        _this.blockCategories = '';
        _this.blockKeywords = [];
        _this.account = Object.assign({}, data);
        return _this;
    }
    SetPlaceSourceModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            googleKey: [null, null],
            blockCategories: [null, null],
        });
        this.loading = true;
        this.accountApiService.getPlaceSource(this.account.account.userName)
            .subscribe(function (source) {
            if (source && source.place) {
                _this.placeSource = source.place;
                _this.initial = _this.placeSource;
                _this.googleKey = source.googleKey;
                _this.businessType = source.businessType;
                _this.isUseIgDefaultCustomPlaceCategories = source.isUseIgDefaultCustomPlaceCategories;
                _this.blockKeywords = source.blockPlaceKeywords ? source.blockPlaceKeywords.split(', ') : [];
                if (_this.placeSource && _this.placeSource === 'google') {
                    _this.accountApiService.getGooglePlaceBlockedCategories(_this.account.account.userName).subscribe(function (data) {
                        _this.blockCategories = (data && data.value && data.value) || '';
                    });
                }
                _this.showPlaceImageCount = source.placeImagesShownCount;
                _this.nearbyPlacesDefaultRange = source.nearbyPlacesDefaultRange;
            }
            _this.loading = false;
        });
    };
    SetPlaceSourceModalComponent.prototype.setPlaceSource = function () {
        var _this = this;
        var actions = {
            confirm: function (event) {
                if (_this.placeSource === 'facebook') {
                    _this.accountApiService
                        .setPlaceSource(_this.account.account.userName, _this.placeSource, _this.googleKey)
                        .subscribe(function (data) {
                        _this.alertify.successfully('Set place source');
                        setTimeout(function () {
                            _this.close();
                        }, 1000);
                    });
                    event.complete();
                }
                else {
                    event.complete();
                }
            },
            cancel: function () {
                _this.placeSource = _this.initial;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to set the place source for this account, this will switch client places totally?",
            confirmModalConfirmButtonText: 'Yes',
            confirmModalCancelButtonText: 'No',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    SetPlaceSourceModalComponent.prototype.setBusinessType = function ($event) {
        var _this = this;
        this.accountApiService.setBusinessType(this.account.account._id, this.businessType).subscribe(function (data) {
            _this.alertify.successfully('Set business type');
            $event.complete();
        });
    };
    SetPlaceSourceModalComponent.prototype.savePlaceImagesCount = function (event) {
        var _this = this;
        this.accountApiService
            .setPlaceImagesShown(this.account.account._id, this.showPlaceImageCount)
            .finally(event.complete)
            .subscribe(function (data) {
            _this.alertify.successfully('Set place images count to be shown');
            // this.close();
        });
    };
    SetPlaceSourceModalComponent.prototype.saveNearbyPlacesDefaultRange = function (event) {
        var _this = this;
        this.accountApiService
            .setNearbyPlacesDefaultRange(this.account.account._id, this.nearbyPlacesDefaultRange)
            .finally(event.complete)
            .subscribe(function (data) {
            _this.alertify.successfully('Set nearby places default range');
        });
    };
    SetPlaceSourceModalComponent.prototype.saveGoogleKey = function (event) {
        var _this = this;
        if (!this.googleKey) {
            this.alertify.error('Please enter the Google Appkey!');
            return;
        }
        this.accountApiService
            .setPlaceSource(this.account.account.userName, this.placeSource, this.googleKey)
            .subscribe(function (data) {
            _this.alertify.successfully('Set place source');
            // this.close();
        });
        event.complete();
    };
    SetPlaceSourceModalComponent.prototype.block = function (event) {
        var _this = this;
        this.accountApiService
            .setGooglePlaceBlockedCategories(this.account.account.userName, this.blockCategories)
            .subscribe(function (data) {
            _this.alertify.successfully('Set blocked categories for Google places');
            event.complete();
        });
    };
    SetPlaceSourceModalComponent.prototype.blockPlaceKeywords = function (event) {
        var _this = this;
        this.accountApiService
            .setPlaceBlockedKeywords(this.account.account.userName, this.blockKeywords)
            .subscribe(function (data) {
            _this.alertify.successfully('Set blocked keywords places');
            event.complete();
        });
    };
    SetPlaceSourceModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return SetPlaceSourceModalComponent;
}(BaseComponent));
export { SetPlaceSourceModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.place.source/set.place.source.modal.component.ts.pre-build-optimizer.js